import cx from 'classnames';
import './ReasonsSelector.css';

const ReasonsSelector = ({ reasons, selectedReason, onReasonSelect }) => {
  return (
    <div className="button-container-reasons">
      <p>O que te motivou a dar esta nota? </p>
      <p>Nos conte, qual das categorias abaixo é a razão da sua nota</p>
      {reasons.map(reason => (
        <button
          className={cx('button-reasons', { 'selected-reason': selectedReason && selectedReason.id === reason.id })}
          key={reason.id}
          onClick={() => onReasonSelect(reason.id)}>
          {reason.name}
        </button>
      ))}
    </div>
  );
};

export default ReasonsSelector;